"use strict";
exports.formatRelative = formatRelative;
var _index = require("./differenceInCalendarDays.js");
var _index2 = require("./format.js");
var _index3 = require("./toDate.js");
var _index4 = require("./_lib/defaultLocale.js");
var _index5 = require("./_lib/defaultOptions.js");
function formatRelative(date, baseDate, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const _date = (0, _index3.toDate)(date);
  const _baseDate = (0, _index3.toDate)(baseDate);
  const defaultOptions = (0, _index5.getDefaultOptions)();
  const locale = (_b = (_a = options == null ? void 0 : options.locale) != null ? _a : defaultOptions.locale) != null ? _b : _index4.defaultLocale;
  const weekStartsOn = (_j = (_i = (_f = (_e = options == null ? void 0 : options.weekStartsOn) != null ? _e : (_d = (_c = options == null ? void 0 : options.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) != null ? _f : defaultOptions.weekStartsOn) != null ? _i : (_h = (_g = defaultOptions.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) != null ? _j : 0;
  const diff = (0, _index.differenceInCalendarDays)(_date, _baseDate);
  if (isNaN(diff)) {
    throw new RangeError("Invalid time value");
  }
  let token;
  if (diff < -6) {
    token = "other";
  } else if (diff < -1) {
    token = "lastWeek";
  } else if (diff < 0) {
    token = "yesterday";
  } else if (diff < 1) {
    token = "today";
  } else if (diff < 2) {
    token = "tomorrow";
  } else if (diff < 7) {
    token = "nextWeek";
  } else {
    token = "other";
  }
  const formatStr = locale.formatRelative(token, _date, _baseDate, {
    locale,
    weekStartsOn
  });
  return (0, _index2.format)(_date, formatStr, { locale, weekStartsOn });
}
